import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('Return to the classic look'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/CaseClassicAssetDetailButton/messages.js